import { useTranslations } from 'next-intl';
import { useUnit } from 'effector-react';
import { closeModalEvent, openModalEvent } from '@nx-frontend/shared/ui/modal/modal-store';
import { PopupType } from '@nx-frontend/shared/types';

interface UseDialogParams {
  title: string;
  text: string;
  cancelBtnText?: string;
  confirmBtnText: string;
  onConfirm: () => void;
}

/**
 * Hook for showing dialog with Confirm and Cancel buttons
 * @returns
 */
export function useDialog(): (params: UseDialogParams) => void {
  const [openModal, closeModal] = useUnit([openModalEvent, closeModalEvent]);
  const t = useTranslations('webnotes');

  return ({ title, text, cancelBtnText, confirmBtnText, onConfirm }: UseDialogParams) => {
    openModal({
      title,
      content: PopupType.DIALOG,
      showCloseButton: true,
      closeButtonSize: 18,
      payload: {
        payloadType: PopupType.DIALOG,
        text,
        buttons: [
          {
            text: cancelBtnText || t('webnotes-cancel'),
          },
          {
            text: confirmBtnText,
            main: true,
            onClick: () => {
              onConfirm();
              closeModal();
            },
          },
        ],
      },
    });
  };
}
